import { motion } from "framer-motion";

const OurStory = () => {
  return (
    <section className="py-24 bg-slate-50 overflow-hidden">
      <div className="container-custom">

        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* Content */}

          <motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >

            <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
              Our Story
            </span>

            <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4 leading-tight">
              Building Trust,
              <span className="text-[#F59E0B]">
                {" "}One Project At A Time
              </span>
            </h2>

            <p className="text-gray-600 leading-8 mt-8">
              AZ Construction was founded with a simple vision —
              to provide reliable, transparent and high-quality
              construction and development services that clients
              can trust.
            </p>

            <p className="text-gray-600 leading-8 mt-5">
              Over the years, we have successfully delivered
              residential, commercial and infrastructure projects
              while helping clients navigate property investments,
              documentation processes and government approvals.
            </p>

            <p className="text-gray-600 leading-8 mt-5">
              Through dedication, expertise and a customer-first
              approach, we have built strong relationships with
              homeowners, investors and businesses across the region.
            </p>

            {/* Timeline */}

            <div className="mt-10 space-y-6">

              <div className="flex gap-4">
                <div className="w-12 h-12 rounded-full bg-[#082B57] text-white flex items-center justify-center font-bold">
                  01
                </div>

                <div>
                  <h4 className="font-bold text-[#082B57] text-lg">
                    Company Foundation
                  </h4>

                  <p className="text-gray-600">
                    Started with a mission to deliver quality
                    construction services.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 rounded-full bg-[#082B57] text-white flex items-center justify-center font-bold">
                  02
                </div>

                <div>
                  <h4 className="font-bold text-[#082B57] text-lg">
                    Expansion Into Development
                  </h4>

                  <p className="text-gray-600">
                    Expanded services into property development
                    and project management.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 rounded-full bg-[#082B57] text-white flex items-center justify-center font-bold">
                  03
                </div>

                <div>
                  <h4 className="font-bold text-[#082B57] text-lg">
                    Trusted Industry Partner
                  </h4>

                  <p className="text-gray-600">
                    Today we continue delivering excellence,
                    innovation and customer satisfaction.
                  </p>
                </div>
              </div>

            </div>

          </motion.div>

          {/* Image */}

          <motion.div
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="relative"
          >

            <img
              src="assets/images/our-story.png"
              alt="Our Story"
              className="w-full rounded-3xl shadow-2xl object-cover h-auto"
            />

            {/* Floating Badge */}

            <div className="absolute top-8 right-8 bg-white shadow-xl rounded-2xl px-6 py-5">

              <h3 className="text-4xl font-bold text-[#F59E0B]">
                50+
              </h3>

              <p className="text-[#082B57] font-medium">
                Projects Delivered
              </p>

            </div>

          </motion.div>

        </div>

      </div>
    </section>
  );
};

export default OurStory;